import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import Backdrop from '@material-ui/core/Backdrop';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Drawer from '@material-ui/core/Drawer';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import {schemaMonitorUnsupportedReason} from '../../util/engine-support';
import Switch from '@material-ui/core/Switch';
import Checkbox from '@material-ui/core/Checkbox';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';
import Chip from '@material-ui/core/Chip';
import IconButton from '@material-ui/core/IconButton';
import MuiButton from '@material-ui/core/Button';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Snackbar from '@material-ui/core/Snackbar';
import Typography from '@material-ui/core/Typography';
import {Alert} from 'react-bootstrap';
import Preloader from '../../components/preloader';
import RedactedChip from '../../components/redacted-chip';
import Menu from '@material-ui/core/Menu';
import MenuItemMUI from '@material-ui/core/MenuItem';
import Banner from '../../components/banner';
import Modal from '../../components/modal';
import ErrorBoundary from '../../components/error-boundary';
import EmptyState from '../../components/empty-state-container';
import Button from '../../components/button';
import ChangeRequestDetailSheet from '../../components/change-request-detail-sheet';
import SchemaMonitorResults from './components/schema-monitor-results';


import {
  loadConfigs,
  createConfig,
  updateConfig,
  deleteConfig,
  disableConfig,
  softDeleteConfig,
  loadResults,
  loadChanges,
  runNow,
  loadDashboard,
  loadInstances,
  loadSchemas,
  clearResults,
  loadGroups,
  createGroup,
  updateGroup,
  deleteGroup,
  loadGroupConfigs,
  assignConfigsToGroup,
  removeConfigFromGroup,
  activateGroup,
  deactivateGroup,
  downloadGroupReport,
  applySchemaChangeWorkflowAction,
  rollbackSchemaChangeAction,
} from './schema-monitor.actions';


const FREQUENCY_PRESETS = [
  {label: '15 minutes', value: 15},
  {label: '30 minutes', value: 30},
  {label: '1 hour', value: 60},
  {label: '6 hours', value: 360},
  {label: '24 hours', value: 1440},
  {label: 'Custom', value: 'custom'},
];

const CHANGE_TYPE_COLORS = {
  ADDED: '#4caf50',
  REMOVED: '#f44336',
  MODIFIED: '#ff9800',
};

// Human-readable labels for diff field names (raw camelCase otherwise).
const FIELD_CHANGED_LABELS = {
  columnName: 'Column name',
  dataType: 'Data type',
  maxLength: 'Max length',
  isNullable: 'Nullable',
  defaultValue: 'Default value',
  columnKey: 'Key constraint',
  isUnique: 'Unique constraint',
  isUnsigned: 'Unsigned',
  isZerofill: 'Zerofill',
  isBinary: 'Binary',
  isAutoIncrement: 'Auto increment',
};

const CHAT_PROVIDER_LABELS = {
  slack: 'Slack',
  teams: 'Teams',
  gchat: 'GChat',
};

const NO_ACTION_CHIP_STYLE = {
  color: '#9e9e9e',
  backgroundColor: 'transparent',
  border: '1px dashed #bdbdbd',
};

class SchemaMonitor extends Component {
  // Polling interval ID stored as instance property (not state) to avoid re-renders
  _resultsPollInterval = null;

  startResultsPolling = (configId) => {
    this.stopResultsPolling();
    this._resultsPollInterval = setInterval(() => {
      this.props.loadResults(configId);
    }, 15000);
  };

  stopResultsPolling = () => {
    if (this._resultsPollInterval) {
      clearInterval(this._resultsPollInterval);
      this._resultsPollInterval = null;
    }
  };

  constructor(props) {
    super(props);
    this.drawerErrorRef = React.createRef();
    this.state = {
      menuAnchorEl: null,
      menuOpenId: null,
      // Navigation and containers
      appContentContainer: 'app-content-container',
      configListClass: 'page-content select-container in',
      resultsClass: 'page-content results-container',
      changesClass: 'page-content results-container',
      pageNavContainer: 'hide',
      backdrop: false,

      // Dialog state
      configDialogOpen: false,
      editingConfig: null,

      // Group dialog state
      groupDialogOpen: false,
      editingGroup: null,
      groupName: '',
      groupDescription: '',
      groupIsActive: true,

      // Add configs to group dialog
      addConfigsDialogOpen: false,
      selectedConfigIds: [],
      drawerError: null,

      // Form fields
      selectedInstanceId: '',
      selectedSchemaId: '',
      frequencyPreset: 60,
      customFrequency: '',
      monitorTables: true,
      monitorViews: true,
      monitorStoredProcedures: true,
      monitorTriggers: true,
      monitorFunctions: true,
      isActive: true,
      notifyOnChange: true,
      chatProvider: 'none',
      chatWebhookUrl: '',
      chatChannelName: '',
      monitorStartTime: '',
      monitorEndTime: '',
      monitorStartDate: '',
      monitorEndDate: '',

      // View state
      selectedConfig: null,
      selectedResult: null,
      selectedGroup: null,
      currentView: 'groups', // 'groups', 'list', 'results', 'changes'
      activeTab: 0, // 0 = Ungrouped, 1 = Grouped

      // Delete confirm
      configToDelete: null,
      configToDisable: null,
      groupToDelete: null,

      // Notifications
      snackbarStatus: false,
      bannerType: 'danger',
      showBanner: false,
      bannerTitle: '',
      bannerMessage: '',
      actionTriggered: false,
      triggeredItemName: '',

      // Modal
      modalOpen: false,
      modalTitle: '',
      modalContent: '',
      modalPrimaryButton: '',
      modalSecondaryButton: '',

      // Per-config run tracking
      runningConfigId: null,

      // Workflow dialog state (for schema monitor changes view)
      smWorkflowDialogOpen: false,
      smSelectedChange: null,
      smRollbackDialogOpen: false,
      smRollbackTargetChange: null,
      smRollbackReason: '',
      smRollbackReasonError: false,
    };
  }

  componentDidMount() {
    this.props.loadGroups();
    this.props.loadConfigs();
    if (this.props.instances.length === 0) {
      this.props.loadInstances();
    }

    // Listen for real-time schema change notifications
    if (window.io && typeof window.io.on === 'function') {
      try {
        window.io.on('schema-change-detected', this.handleSchemaChangeNotification);
        window.io.on('schema-run-completed', this.handleRunCompletedNotification);
      } catch (e) {
        // Socket.io not available
      }
    }
  }

  componentWillUnmount() {
    this.stopResultsPolling();
    if (window.io && typeof window.io.off === 'function') {
      try {
        window.io.off('schema-change-detected', this.handleSchemaChangeNotification);
        window.io.off('schema-run-completed', this.handleRunCompletedNotification);
      } catch (e) {
        // Socket.io not available
      }
    }
  }

  handleSchemaChangeNotification = (data) => {
    this.setState({
      showBanner: true,
      bannerType: 'info',
      bannerTitle: 'Schema Change Detected',
      bannerMessage: `Changes detected in ${data.instanceName} / ${data.schemaName}: ${data.totalChanges} change(s)`,
      runningConfigId: null,
    });
    this.props.loadConfigs();
    if (this.state.selectedConfig && this.state.selectedConfig.config_id === data.configId) {
      this.props.loadResults(data.configId);
    }
  };

  handleRunCompletedNotification = (data) => {
    this.props.loadConfigs();
    if (this.state.selectedConfig && this.state.selectedConfig.config_id === data.configId) {
      this.props.loadResults(data.configId);
    }
    if (this.state.runningConfigId === data.configId) {
      this.setState({runningConfigId: null});
    }
  };

  goToTop = () => {
    document.getElementById('app').scrollTo(0, 0);
  };

  dismissBanner = () => {
    this.setState({showBanner: false});
  };

  snackHandler = (state) => {
    this.setState({snackbarStatus: state});
  };

  toggleBackdrop = () => {
    this.state.backdrop ?
      this.setState({backdrop: false, pageNavContainer: 'page-nav-container'}) :
      this.setState({backdrop: true, pageNavContainer: 'page-nav-container reduce-zindex'});
  };

  modalConfirm = () => {
    if (this.state.configToDisable) {
      this.handleDisableConfirm();
    } else if (this.state.configToDelete) {
      this.handleSoftDeleteConfirm();
    } else if (this.state.groupToDelete) {
      this.handleDeleteGroupConfirm();
    }
    this.setState({modalOpen: false, configToDisable: null, configToDelete: null, groupToDelete: null});
  };

  modalClose = () => {
    this.setState({modalOpen: false, configToDisable: null, configToDelete: null, groupToDelete: null});
  };

  goBack = (level) => {
    if (this.state.currentView === 'changes') {
      // Go back from changes to results
      this.handleBackToResults();
    } else if (this.state.currentView === 'results') {
      // Go back from results to config list (group detail or top-level)
      if (this.state.selectedGroup) {
        this.handleBackToGroupDetail(this.state.selectedGroup);
      } else {
        this.handleBackToConfigs();
      }
    } else if (this.state.currentView === 'list' && this.state.selectedGroup) {
      // Go back from group detail to groups list
      this.handleBackToGroups();
    } else {
      // Go back to groups landing page
      this.stopResultsPolling();
      this.setState({
        appContentContainer: 'app-content-container',
        configListClass: 'page-content select-container in',
        resultsClass: 'page-content results-container',
        changesClass: 'page-content results-container',
        pageNavContainer: 'hide',
        selectedConfig: null,
        selectedResult: null,
        selectedGroup: null,
        currentView: 'groups',
      });
    }
  };

  handleViewResults = (config) => {
    this.props.clearResults();
    this.setState({
      menuAnchorEl: null,
      menuOpenId: null,
      appContentContainer: 'app-content-container in',
      configListClass: 'page-content select-container',
      resultsClass: 'page-content results-container in',
      changesClass: 'page-content results-container',
      pageNavContainer: 'page-nav-container',
      selectedConfig: config,
      selectedResult: null,
      currentView: 'results',
    });
    this.props.loadResults(config.config_id);
    this.startResultsPolling(config.config_id);
    this.goToTop();
  };

  handleBackToConfigs = () => {
    this.stopResultsPolling();
    this.props.clearResults();
    this.setState({
      appContentContainer: 'app-content-container',
      configListClass: 'page-content select-container in',
      resultsClass: 'page-content results-container',
      changesClass: 'page-content results-container',
      pageNavContainer: 'hide',
      selectedConfig: null,
      selectedResult: null,
      currentView: 'groups',
    });
  };

  handleBackToGroups = () => {
    this.stopResultsPolling();
    this.props.clearResults();
    this.props.loadGroups();
    this.setState({
      appContentContainer: 'app-content-container',
      configListClass: 'page-content select-container in',
      resultsClass: 'page-content results-container',
      changesClass: 'page-content results-container',
      pageNavContainer: 'hide',
      selectedConfig: null,
      selectedResult: null,
      selectedGroup: null,
      currentView: 'groups',
    });
  };

  handleViewGroupDetail = (group) => {
    this.props.loadGroupConfigs(group.group_id);
    this.props.loadConfigs();
    this.setState({
      menuAnchorEl: null,
      menuOpenId: null,
      appContentContainer: 'app-content-container in',
      configListClass: 'page-content select-container in',
      resultsClass: 'page-content results-container',
      changesClass: 'page-content results-container',
      pageNavContainer: 'page-nav-container',
      selectedGroup: group,
      selectedConfig: null,
      selectedResult: null,
      currentView: 'list',
    });
    this.goToTop();
  };

  handleBackToGroupDetail = (group) => {
    this.stopResultsPolling();
    this.props.clearResults();
    this.props.loadGroupConfigs(group.group_id);
    this.setState({
      appContentContainer: 'app-content-container in',
      configListClass: 'page-content select-container in',
      resultsClass: 'page-content results-container',
      changesClass: 'page-content results-container',
      pageNavContainer: 'page-nav-container',
      selectedConfig: null,
      selectedResult: null,
      currentView: 'list',
    });
  };

  handleBackToResults = () => {
    this.setState({
      appContentContainer: 'app-content-container in',
      configListClass: 'page-content select-container',
      resultsClass: 'page-content results-container in',
      changesClass: 'page-content results-container',
      pageNavContainer: 'page-nav-container',
      selectedResult: null,
      currentView: 'results',
    });
  };

  handleOpenCreate = () => {
    this.setState({
      configDialogOpen: true,
      editingConfig: null,
      drawerError: null,
      selectedInstanceId: '',
      selectedSchemaId: '',
      frequencyPreset: 60,
      customFrequency: '',
      monitorTables: true,
      monitorViews: true,
      monitorStoredProcedures: true,
      monitorTriggers: true,
      monitorFunctions: true,
      isActive: true,
      notifyOnChange: true,
      chatProvider: 'none',
      chatWebhookUrl: '',
      chatChannelName: '',
      monitorStartTime: '',
      monitorEndTime: '',
      monitorStartDate: '',
      monitorEndDate: '',
    });
    if (this.props.instances.length === 0) {
      this.props.loadInstances();
    }
  };

  handleOpenEdit = (config) => {
    const freq = FREQUENCY_PRESETS.find((p) => p.value === config.frequency_minutes);
    this.setState({
      menuAnchorEl: null,
      menuOpenId: null,
      configDialogOpen: true,
      editingConfig: config,
      drawerError: null,
      selectedInstanceId: config.instance_id,
      selectedSchemaId: config.schema_id,
      frequencyPreset: freq ? config.frequency_minutes : 'custom',
      customFrequency: freq ? '' : String(config.frequency_minutes),
      monitorTables: !!config.monitor_tables,
      monitorViews: !!config.monitor_views,
      monitorStoredProcedures: !!config.monitor_stored_procedures,
      monitorTriggers: config.monitor_triggers !== undefined ? !!config.monitor_triggers : !!config.monitor_stored_procedures,
      monitorFunctions: config.monitor_functions !== undefined ? !!config.monitor_functions : !!config.monitor_stored_procedures,
      isActive: !!config.is_active,
      notifyOnChange: !!config.notify_on_change,
      chatProvider: config.chat_provider || 'none',
      chatWebhookUrl: config.chat_webhook_url || '',
      chatChannelName: config.chat_channel_name || '',
      monitorStartTime: config.monitor_start_time || '',
      monitorEndTime: config.monitor_end_time || '',
      monitorStartDate: config.monitor_start_date ? config.monitor_start_date.substring(0, 10) : '',
      monitorEndDate: config.monitor_end_date ? config.monitor_end_date.substring(0, 10) : '',
    });
    if (this.props.instances.length === 0) {
      this.props.loadInstances();
    }
    if (config.instance_id) {
      this.props.loadSchemas(config.instance_id);
    }
  };

  handleOpenCreateGroup = () => {
    this.setState({
      groupDialogOpen: true,
      editingGroup: null,
      groupName: '',
      groupDescription: '',
      groupIsActive: true,
    });
  };

  handleOpenEditGroup = (group) => {
    this.setState({
      menuAnchorEl: null,
      menuOpenId: null,
      groupDialogOpen: true,
      editingGroup: group,
      groupName: group.group_name || '',
      groupDescription: group.description || '',
      groupIsActive: !!group.is_active,
    });
  };

  handleCloseGroupDialog = () => {
    this.setState({groupDialogOpen: false, editingGroup: null});
  };

  handleSaveGroup = () => {
    const {groupName, groupDescription, groupIsActive, editingGroup} = this.state;
    const data = {groupName, description: groupDescription, isActive: groupIsActive};
    const savePromise = editingGroup ?
      this.props.updateGroup(editingGroup.group_id, data) :
      this.props.createGroup(data);
    this.handleCloseGroupDialog();
    if (savePromise && typeof savePromise.then === 'function') {
      savePromise.then(() => this.props.loadGroups());
    } else {
      this.props.loadGroups();
    }
  };

  handleDeleteGroupClick = (group) => {
    this.setState({
      menuAnchorEl: null,
      menuOpenId: null,
      modalOpen: true,
      modalTitle: 'Confirm Delete Group',
      modalContent: `Are you sure you want to delete the group "${group.group_name}"? Configs in this group will be unassigned.`,
      modalPrimaryButton: 'Delete',
      modalSecondaryButton: 'Cancel',
      groupToDelete: group,
      configToDelete: null,
      configToDisable: null,
    });
  };

  handleOpenAddConfigs = (group) => {
    // Load existing configs in the group as pre-selected
    const {configs} = this.props;
    const groupConfigIds = configs
        .filter((config) => config.group_id === group.group_id)
        .map((config) => config.config_id);
    this.setState({addConfigsDialogOpen: true, selectedConfigIds: groupConfigIds});
  };

  handleCloseAddConfigs = () => {
    this.setState({addConfigsDialogOpen: false, selectedConfigIds: []});
  };

  handleAssignConfigs = () => {
    const {selectedGroup, selectedConfigIds} = this.state;
    const {configs} = this.props;

    if (!selectedGroup) return;

    // Get current group config IDs
    const currentGroupConfigIds = configs
        .filter((config) => config.group_id === selectedGroup.group_id)
        .map((config) => config.config_id);

    // Find configs to add (selected but not in group)
    const configsToAdd = selectedConfigIds.filter((id) => !currentGroupConfigIds.includes(id));

    // Find configs to remove (in group but not selected)
    const configsToRemove = currentGroupConfigIds.filter((id) => !selectedConfigIds.includes(id));

    // Add new configs
    if (configsToAdd.length > 0) {
      const addPromise = this.props.assignConfigsToGroup(selectedGroup.group_id, configsToAdd);
      if (addPromise && typeof addPromise.then === 'function') {
        addPromise.then(() => {
          this.props.loadGroupConfigs(selectedGroup.group_id);
          this.props.loadConfigs();
        });
      }
    }

    // Remove unselected configs
    if (configsToRemove.length > 0) {
      configsToRemove.forEach((configId) => {
        const removePromise = this.props.removeConfigFromGroup(selectedGroup.group_id, configId);
        if (removePromise && typeof removePromise.then === 'function') {
          removePromise.then(() => {
            this.props.loadGroupConfigs(selectedGroup.group_id);
            this.props.loadConfigs();
          });
        }
      });
    }

    this.handleCloseAddConfigs();
  };

  handleRemoveConfigFromGroup = (configId) => {
    this.setState({menuAnchorEl: null, menuOpenId: null});
    const {selectedGroup} = this.state;
    if (!selectedGroup) return;
    const p = this.props.removeConfigFromGroup(selectedGroup.group_id, configId);
    if (p && typeof p.then === 'function') {
      p.then(() => {
        this.props.loadGroupConfigs(selectedGroup.group_id);
        this.props.loadConfigs();
      });
    }
  };

  handleToggleGroupActive = (group) => {
    this.setState({menuAnchorEl: null, menuOpenId: null});
    const action = group.is_active ?
      this.props.deactivateGroup(group.group_id) :
      this.props.activateGroup(group.group_id);
    if (action && typeof action.then === 'function') {
      action.then(() => {
        this.props.loadGroups();
        this.props.loadConfigs();
        if (this.state.selectedGroup && this.state.selectedGroup.group_id === group.group_id) {
          // Update the selected group state to reflect the new active status
          this.setState({
            selectedGroup: {
              ...this.state.selectedGroup,
              is_active: !group.is_active,
            },
          });
          this.props.loadGroupConfigs(group.group_id);
        }
      });
    }
  };

  handleCloseDialog = () => {
    this.setState({
      configDialogOpen: false,
      editingConfig: null,
      selectedInstanceId: '',
      selectedSchemaId: '',
      frequencyPreset: 60,
      customFrequency: '',
      monitorTables: true,
      monitorViews: true,
      monitorStoredProcedures: true,
      monitorTriggers: true,
      monitorFunctions: true,
      isActive: true,
      notifyOnChange: true,
      chatProvider: 'none',
      chatWebhookUrl: '',
      chatChannelName: '',
      monitorStartTime: '',
      monitorEndTime: '',
      monitorStartDate: '',
      monitorEndDate: '',
      drawerError: null,
    });
  };

  handleInstanceChange = (e) => {
    const instanceId = e.target.value;
    this.setState({selectedInstanceId: instanceId, selectedSchemaId: ''});
    if (instanceId) {
      this.props.loadSchemas(instanceId);
    }
  };

  handleSaveConfig = () => {
    const {
      selectedInstanceId, selectedSchemaId, frequencyPreset, customFrequency,
      monitorTables, monitorViews, monitorStoredProcedures, monitorTriggers, monitorFunctions, isActive, notifyOnChange,
      chatProvider, chatWebhookUrl, chatChannelName,
      monitorStartTime, monitorEndTime,
      monitorStartDate, monitorEndDate,
      editingConfig,
    } = this.state;

    const frequencyMinutes = frequencyPreset === 'custom' ?
      parseInt(customFrequency, 10) || 60 :
      frequencyPreset;

    const scrollToDrawerError = () => {
      if (this.drawerErrorRef && this.drawerErrorRef.current) {
        this.drawerErrorRef.current.scrollIntoView({behavior: 'smooth', block: 'nearest'});
        this.drawerErrorRef.current.focus();
      }
    };

    // Validate: both or neither time boundaries must be provided
    if ((monitorStartTime && !monitorEndTime) || (!monitorStartTime && monitorEndTime)) {
      this.setState({
        drawerError: {
          title: 'Invalid Time Range',
          message: 'Both Monitor Start Time and Monitor End Time must be provided, or leave both empty.',
        },
      }, scrollToDrawerError);
      return;
    }

    if (monitorStartTime && monitorEndTime) {
      const fallbackDate = monitorStartDate || monitorEndDate || '1970-01-01';
      const startDT = new Date(`${monitorStartDate || fallbackDate}T${monitorStartTime}`);
      const endDT = new Date(`${monitorEndDate || fallbackDate}T${monitorEndTime}`);
      if (startDT.getTime() === endDT.getTime()) {
        this.setState({
          drawerError: {
            title: 'Invalid Time Range',
            message: 'Monitor Start Date/Time and Monitor End Date/Time cannot be the same.',
          },
        }, scrollToDrawerError);
        return;
      }
      if (endDT < startDT) {
        this.setState({
          drawerError: {
            title: 'Invalid Time Range',
            message: 'Monitor End Date/Time must be after Monitor Start Date/Time.',
          },
        }, scrollToDrawerError);
        return;
      }
    }

    // Validate: end date must not be in the past
    if (monitorEndDate) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const endDate = new Date(monitorEndDate);
      if (endDate < today) {
        this.setState({
          drawerError: {
            title: 'Invalid End Date',
            message: 'Monitor End Date is in the past. The config would be auto-disabled immediately.',
          },
        }, scrollToDrawerError);
        return;
      }
    }

    // Validate date range
    if (monitorStartDate && monitorEndDate && monitorEndDate < monitorStartDate) {
      this.setState({
        drawerError: {
          title: 'Invalid Date Range',
          message: 'Monitor End Date must be on or after Monitor Start Date.',
        },
      }, scrollToDrawerError);
      return;
    }

    const data = {
      instanceId: selectedInstanceId,
      schemaId: selectedSchemaId,
      frequencyMinutes,
      monitorTables,
      monitorViews,
      monitorStoredProcedures,
      monitorTriggers,
      monitorFunctions,
      isActive,
      notifyOnChange,
      chatProvider,
      chatWebhookUrl: chatWebhookUrl || null,
      chatChannelName: chatChannelName || null,
      monitorStartTime: monitorStartTime || null,
      monitorEndTime: monitorEndTime || null,
      monitorStartDate: monitorStartDate || null,
      monitorEndDate: monitorEndDate || null,
    };

    const savePromise = editingConfig ?
      this.props.updateConfig(editingConfig.config_id, data) :
      this.props.createConfig(data);
    this.handleCloseDialog();
    if (savePromise && typeof savePromise.then === 'function') {
      savePromise.then(() => {
        this.props.loadConfigs();
        if (this.state.selectedGroup) {
          this.props.loadGroupConfigs(this.state.selectedGroup.group_id);
        }
      });
    } else {
      this.props.loadConfigs();
    }
  };

  handleDisableClick = (config) => {
    this.setState({
      menuAnchorEl: null,
      menuOpenId: null,
      modalOpen: true,
      modalTitle: 'Confirm Disable',
      modalContent: `Are you sure you want to disable the monitor configuration for ${config.instance_name} / ${config.schema_name}?`,
      modalPrimaryButton: 'Disable',
      modalSecondaryButton: 'Cancel',
      configToDisable: config,
      configToDelete: null,
    });
  };

  handleSoftDeleteClick = (config) => {
    this.setState({
      menuAnchorEl: null,
      menuOpenId: null,
      modalOpen: true,
      modalTitle: 'Confirm Delete',
      modalContent: `Are you sure you want to delete the monitor configuration for ${config.instance_name} / ${config.schema_name}? This will hide it from the UI but preserve all execution history.`,
      modalPrimaryButton: 'Delete',
      modalSecondaryButton: 'Cancel',
      configToDelete: config,
      configToDisable: null,
    });
  };

  handleDisableConfirm = () => {
    if (this.state.configToDisable) {
      this.props.disableConfig(this.state.configToDisable.config_id);
      setTimeout(() => this.props.loadConfigs(), 500);
    }
  };

  handleSoftDeleteConfirm = () => {
    if (this.state.configToDelete) {
      this.props.softDeleteConfig(this.state.configToDelete.config_id);
      setTimeout(() => this.props.loadConfigs(), 500);
    }
  };

  handleDeleteGroupConfirm = () => {
    if (this.state.groupToDelete) {
      const p = this.props.deleteGroup(this.state.groupToDelete.group_id);
      const refresh = () => {
        this.props.loadGroups();
        this.props.loadConfigs();
      };
      if (p && typeof p.then === 'function') {
        p.then(refresh);
      } else {
        setTimeout(refresh, 500);
      }
    }
  };


  handleViewChanges = (result) => {
    this.setState({
      appContentContainer: 'app-content-container in',
      configListClass: 'page-content select-container',
      resultsClass: 'page-content results-container',
      changesClass: 'page-content results-container in',
      pageNavContainer: 'page-nav-container',
      selectedResult: result,
      currentView: 'changes',
    });
    this.props.loadChanges(result.result_id);
    this.goToTop();
  };

  handleRunNow = (configId) => {
    if (this.state.runningConfigId === configId) return; // Prevent duplicate run of same config
    this.setState({runningConfigId: configId});
    const runPromise = this.props.runNow(configId);
    if (runPromise && typeof runPromise.then === 'function') {
      runPromise.then(() => {
        if (this.state.selectedConfig && this.state.selectedConfig.config_id === configId) {
          this.props.clearResults();
          this.props.loadResults(configId);
        }
        this.setState({runningConfigId: null});
      });
    }
  };

  renderChangeTypeChip = (changeType) => {
    const colorClassMap = {
      ADDED: 'chip-green',
      REMOVED: 'chip-red',
      MODIFIED: 'chip-orange',
    };

    return (
      <Chip
        label={changeType}
        size="small"
        className={`change-type-chip ${colorClassMap[changeType] || 'chip-grey'}`}
      />
    );
  };

  renderWorkflowStatusChip = (status) => {
    if (!status) return null;
    const styleMap = {
      PENDING: {backgroundColor: '#e3f2fd', color: '#1565c0', border: '1px solid #90caf9'},
      APPROVED: {backgroundColor: '#e8f5e9', color: '#2e7d32', border: '1px solid #a5d6a7'},
      REJECTED: {backgroundColor: '#ffebee', color: '#c62828', border: '1px solid #ef9a9a'},
      ROLLED_BACK: {backgroundColor: '#f3e5f5', color: '#6a1b9a', border: '1px solid #ce93d8'},
    };
    return (
      <Chip
        label={status}
        size="small"
        style={styleMap[status] || {backgroundColor: '#f5f5f5', color: '#616161'}}
      />
    );
  };

  openSmWorkflowDialog = (change) => {
    this.setState({
      smWorkflowDialogOpen: true,
      smSelectedChange: change,
    });
  };

  closeSmWorkflowDialog = () => {
    this.setState({
      smWorkflowDialogOpen: false,
      smSelectedChange: null,
    });
  };

  buildDiffSummary = (change) => {
    const parts = [change.change_type, change.object_name];
    if (change.column_name) parts.push(`.${change.column_name}`);
    if (change.field_changed) parts.push(`(${change.field_changed})`);
    return parts.join(' ');
  };

  submitSmWorkflowAction = (action, comments) => {
    const {smSelectedChange} = this.state;
    if (!action || !smSelectedChange) return;

    // No payload of detected values: the server reads the change from its own
    // dd_schema_change_details row by change_id. Sending them was how a client could write content
    // of its choosing into a change request and, on approval, into the data dictionary.
    this.props.applySchemaChangeWorkflowAction(
        smSelectedChange.change_id,
        action,
        comments,
    ).then(() => {
      // Reload changes to reflect updated workflow status
      if (this.state.selectedResult) {
        this.props.loadChanges(this.state.selectedResult.result_id);
      }
      this.closeSmWorkflowDialog();
    }).catch(() => {
      this.closeSmWorkflowDialog();
    });
  };

  openSmRollbackDialog = (change) => {
    this.setState({
      smRollbackDialogOpen: true,
      smRollbackTargetChange: change,
      smRollbackReason: '',
      smRollbackReasonError: false,
    });
  };

  closeSmRollbackDialog = () => {
    this.setState({
      smRollbackDialogOpen: false,
      smRollbackTargetChange: null,
      smRollbackReason: '',
      smRollbackReasonError: false,
    });
  };

  confirmSmRollback = () => {
    const {smRollbackTargetChange, smRollbackReason} = this.state;
    if (!smRollbackReason || !smRollbackReason.trim()) {
      this.setState({smRollbackReasonError: true});
      return;
    }
    if (smRollbackTargetChange && smRollbackTargetChange.workflow_request_id) {
      this.props.rollbackSchemaChangeAction(smRollbackTargetChange.workflow_request_id, smRollbackReason.trim())
          .then(() => {
            if (this.state.selectedResult) {
              this.props.loadChanges(this.state.selectedResult.result_id);
            }
            this.closeSmRollbackDialog();
          }).catch(() => {
            this.closeSmRollbackDialog();
          });
    }
  };

  // Transform schema monitor change to workflow change request format
  transformSmChangeToWorkflowFormat = (smChange) => {
    if (!smChange) return null;

    // Build diff summary
    const diffParts = [];
    if (smChange.field_changed) {
      diffParts.push(`${smChange.field_changed}: ${smChange.old_value} → ${smChange.new_value}`);
    }

    return {
      request_id: smChange.change_id,
      object_name: smChange.object_name,
      column_name: smChange.column_name,
      change_type: smChange.change_type,
      change_source: 'SCHEMA_MONITOR',
      status: smChange.workflow_status || 'PENDING',
      requested_by: 'System',
      requested_by_name: 'Schema Monitor',
      requested_at: smChange.detected_at || new Date().toISOString(),
      diff_summary: this.buildDiffSummary(smChange),
      proposed_changes: {
        fieldChanges: smChange.field_changed ? [{
          field: smChange.field_changed,
          oldValue: smChange.old_value,
          newValue: smChange.new_value,
        }] : [],
      },
    };
  };

  handleSmNavigate = (direction) => {
    const {smSelectedChange} = this.state;
    const {changes} = this.props;

    if (!smSelectedChange || !changes) return;

    const currentIndex = changes.findIndex((c) => c.change_id === smSelectedChange.change_id);
    if (direction === 'prev' && currentIndex > 0) {
      this.setState({smSelectedChange: changes[currentIndex - 1]});
    } else if (direction === 'next' && currentIndex < changes.length - 1) {
      this.setState({smSelectedChange: changes[currentIndex + 1]});
    }
  };

  canSmRollback = (status) => {
    return ['APPROVED', 'REJECTED'].includes(status);
  };

  renderSmRollbackDialog = () => {
    const {smRollbackDialogOpen, smRollbackTargetChange, smRollbackReason, smRollbackReasonError} = this.state;
    const isRollingBack = (this.props.isLoading || []).includes('smworkflowrollback');

    return (
      <Dialog open={smRollbackDialogOpen} onClose={this.closeSmRollbackDialog} maxWidth="sm" fullWidth>
        <DialogTitle>
          <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
            <span className="material-icons" style={{color: '#e65100'}}>undo</span>
            <span>Confirm Rollback</span>
          </div>
        </DialogTitle>
        <DialogContent dividers>
          {smRollbackTargetChange && (
            <div style={{marginBottom: 16}}>
              <Typography variant="body2" style={{marginBottom: 12, color: '#555'}}>
                You are about to roll back the <strong>{smRollbackTargetChange.workflow_status}</strong> decision for:
              </Typography>
              <Typography variant="body1" style={{marginBottom: 4}}>
                <strong>{smRollbackTargetChange.object_name || 'N/A'}</strong>
                {smRollbackTargetChange.column_name && ` → ${smRollbackTargetChange.column_name}`}
              </Typography>
              <div style={{display: 'flex', gap: 8, marginBottom: 12}}>
                {this.renderWorkflowStatusChip(smRollbackTargetChange.workflow_status)}
              </div>
              {smRollbackTargetChange.workflow_status === 'APPROVED' && (
                <Typography variant="body2" style={{color: '#e65100', marginBottom: 12}}>
                  Warning: Rolling back an Approved change will restore the previous state.
                </Typography>
              )}
            </div>
          )}
          <TextField
            label="Reason for Rollback *"
            value={smRollbackReason}
            onChange={(e) => this.setState({smRollbackReason: e.target.value, smRollbackReasonError: false})}
            fullWidth
            multiline
            rows={3}
            error={smRollbackReasonError}
            helperText={smRollbackReasonError ? 'A reason is required to perform a rollback.' : ''}
            placeholder="Explain why this decision is being rolled back..."
          />
        </DialogContent>
        <DialogActions>
          <MuiButton onClick={this.closeSmRollbackDialog} disabled={isRollingBack}>Cancel</MuiButton>
          <MuiButton
            onClick={this.confirmSmRollback}
            variant="contained"
            disabled={isRollingBack}
            style={{backgroundColor: '#e65100', color: '#fff'}}
          >
            {isRollingBack ? 'Rolling Back...' : 'Confirm Rollback'}
          </MuiButton>
        </DialogActions>
      </Dialog>
    );
  };

  renderStatusChip = (status) => {
    return (
      <Chip
        label={status}
        className={`status-${status.toLowerCase()}`}
      />
    );
  };

  render() {
    const {
      configs, results, changes, instances, schemas, groups, groupConfigs,
      isLoading,
    } = this.props;
    const {
      configDialogOpen, editingConfig, selectedInstanceId, selectedSchemaId,
      frequencyPreset, customFrequency, monitorTables, monitorViews,
      monitorStoredProcedures, monitorTriggers, monitorFunctions, isActive, notifyOnChange,
      chatProvider, chatWebhookUrl, chatChannelName,
      monitorStartTime, monitorEndTime,
      monitorStartDate, monitorEndDate,
      selectedConfig, selectedResult, selectedGroup,
      groupDialogOpen, editingGroup, groupName, groupDescription, groupIsActive,
      addConfigsDialogOpen, selectedConfigIds,
      currentView,
    } = this.state;

    const isLoadingConfigs = isLoading.includes('configs');
    const isLoadingResults = isLoading.includes('results');
    const isLoadingChanges = isLoading.includes('changes');
    const isLoadingGroups = isLoading.includes('groups');
    const {runningConfigId} = this.state;

    // Determine which configs to show in the list view
    const displayConfigs = selectedGroup ?
      (groupConfigs || []) :
      configs;

    // Ungrouped configs for the groups view
    const ungroupedConfigs = configs.filter((c) => !c.group_id);

    return (
      <div className={this.state.appContentContainer}>

        <Backdrop open={this.state.backdrop}></Backdrop>

        <Snackbar
          open={this.state.snackbarStatus}
          message="Please wait..."
          className="snack-bar"
        />

        <div className={this.state.pageNavContainer}>
          <a onClick={this.goBack.bind(this, 0)} className="back-link">
            <i className="material-icons">arrow_back</i>
            Back
          </a>
        </div>

        <Modal
          open={this.state.modalOpen}
          title={this.state.modalTitle}
          content={this.state.modalContent}
          primaryButton={this.state.modalPrimaryButton}
          secondaryButton={this.state.modalSecondaryButton}
          close={this.modalClose}
          confirm={this.modalConfirm}
        />

        <Banner
          type={this.state.bannerType}
          hasAlerts={this.state.showBanner}
          header={this.state.bannerTitle}
          body={this.state.bannerMessage}
          dismissBanner={this.dismissBanner.bind(this)}
        />

        {/* ── Groups List View ──────────────────────────────────────────── */}
        {currentView === 'groups' && (
          <div className="page-content results-container in">
            <h2>Schema Change Monitor</h2>
            <ErrorBoundary>
              <Tabs className='recon-tabs' onChange={(e, value) => this.setState({activeTab: value})} value={this.state.activeTab}>
                <Tab label="Ungrouped" value={0} data-testid="sm-tab-ungrouped" />
                <Tab label="Grouped" value={1} data-testid="sm-tab-grouped" />
              </Tabs>
              {this.state.activeTab === 0 && (
                <div className='tab-content'>
                  <div className='cz-container'>
                    <div className='action-bar padding-20'>
                      <Button label="Add New Monitor Config" className="btn btn-action" onClick={this.handleOpenCreate} data-testid="sm-add-config-btn" />
                    </div>

                    {isLoadingConfigs ? (
                    <Preloader loading={true} />
                  ) : ungroupedConfigs.length === 0 ? (
                    <div data-testid="sm-empty-ungrouped"><EmptyState message="No ungrouped configurations. Create a new monitor config to get started." /></div>
                  ) : (
                    <Table className='data-table clickable' data-testid="sm-config-table">
                      <TableHead>
                        <TableRow>
                          <TableCell>Instance</TableCell>
                          <TableCell>Schema</TableCell>
                          <TableCell>Frequency</TableCell>
                          <TableCell>Monitor</TableCell>
                          <TableCell>Run Status</TableCell>
                          <TableCell>Change Status</TableCell>
                          <TableCell>Last Run</TableCell>
                          <TableCell>Actions</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {ungroupedConfigs.map((config) => (
                          <TableRow key={config.config_id} hover data-testid="sm-config-row" data-config-id={config.config_id}>
                            <TableCell
                              className="link-text"
                              onClick={() => this.handleViewResults(config)}
                            >
                              {config.instance_name}
                            </TableCell>
                            <TableCell>{config.schema_name}</TableCell>
                            <TableCell>{config.frequency_minutes} min</TableCell>
                            <TableCell>
                              {[
                                config.monitor_tables && 'Tables',
                                config.monitor_views && 'Views',
                                config.monitor_stored_procedures && 'Stored Procedures',
                                (config.monitor_triggers !== undefined ? config.monitor_triggers : config.monitor_stored_procedures) && 'Triggers',
                                (config.monitor_functions !== undefined ? config.monitor_functions : config.monitor_stored_procedures) && 'Functions',
                                config.chat_provider && config.chat_provider !== 'none' && CHAT_PROVIDER_LABELS[config.chat_provider],
                              ].filter(Boolean).join(', ')}
                            </TableCell>
                            <TableCell>
                              <Chip
                                label={config.is_active ? 'Active' : 'Inactive'}
                                size="small"
                                className={`status-chip ${config.is_active ? 'status-active' : 'status-inactive'}`}
                              />
                            </TableCell>
                            <TableCell data-testid="sm-change-status" data-status={config.has_changes ? 'detected' : config.last_run_at ? 'clean' : 'none'}>
                              {config.has_changes ? (
                                <Chip label="Change Detected" size="small" className="status-chip chip-orange" />
                              ) : config.last_run_at ? (
                                <Chip label="No Changes" size="small" className="status-chip chip-grey" />
                              ) : (
                                <span>—</span>
                              )}
                            </TableCell>
                            <TableCell>
                              {config.last_run_at ? new Date(config.last_run_at).toLocaleString() : '—'}
                            </TableCell>
                            <TableCell>
                              <div className='row-actions-container'>
                                <Tooltip title={config.is_active ? 'Run Now' : 'Monitor is inactive — activate it to run'}>
                                  <span>
                                    <IconButton
                                      size="small"
                                      onClick={() => this.handleRunNow(config.config_id)}
                                      disabled={this.state.runningConfigId === config.config_id || !config.is_active}
                                      data-testid="sm-run-now"
                                    >
                                      <i className='material-icons'>play_arrow</i>
                                    </IconButton>
                                  </span>
                                </Tooltip>
                                <div className='actions-menu'>
                                  <IconButton onClick={(e) => this.setState({menuAnchorEl: e.currentTarget, menuOpenId: 'ungrouped_' + config.config_id})} data-testid="sm-config-menu">
                                    <i className='material-icons'>more_horiz</i>
                                  </IconButton>
                                  <Menu
                                    anchorEl={this.state.menuAnchorEl}
                                    open={Boolean(this.state.menuAnchorEl) && this.state.menuOpenId === 'ungrouped_' + config.config_id}
                                    onClose={() => this.setState({menuAnchorEl: null, menuOpenId: null})}
                                    anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                                    transformOrigin={{horizontal: 'right', vertical: 'top'}}
                                  >
                                    <MenuItemMUI
                                      className='wl-group-card-menu'
                                      onClick={() => this.handleViewResults(config)}
                                      data-testid="sm-menu-view-results"
                                    >View Results</MenuItemMUI>
                                    <MenuItemMUI
                                      className='wl-group-card-menu'
                                      onClick={() => this.handleOpenEdit(config)}
                                      data-testid="sm-menu-edit"
                                    >Edit</MenuItemMUI>
                                    <MenuItemMUI
                                      className='wl-group-card-menu'
                                      onClick={() => this.handleSoftDeleteClick(config)}
                                      data-testid="sm-menu-delete"
                                    >Delete</MenuItemMUI>
                                  </Menu>
                                </div>
                              </div>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  )}
                  </div>
                </div>
              )}
              {this.state.activeTab === 1 && (
                <div className='tab-content'>
                  <div className='cz-container'>
                    <div className='action-bar padding-20'>
                      <Button label="Add New Group" className="btn btn-action" onClick={this.handleOpenCreateGroup} data-testid="sm-add-group-btn" />
                    </div>

                    {isLoadingGroups ? (
                    <Preloader loading={true} />
                  ) : groups.length === 0 ? (
                    <div data-testid="sm-empty-grouped"><EmptyState message="No monitor groups yet. Create a group to organize your configurations." /></div>
                  ) : (
                  <Table className='data-table clickable' data-testid="sm-group-table">
                    <TableHead>
                      <TableRow>
                        <TableCell>Group Name</TableCell>
                        <TableCell>Description</TableCell>
                        <TableCell>No. of Active Configs</TableCell>
                        <TableCell>Change Status</TableCell>
                        <TableCell>Run Status</TableCell>
                        <TableCell>Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {groups.map((group) => (
                        <TableRow key={group.group_id} hover data-testid="sm-group-row" data-group-id={group.group_id} data-group-name={group.group_name}>
                          <TableCell
                            className="link-text-bold"
                            onClick={() => this.handleViewGroupDetail(group)}
                          >
                            {group.group_name}
                          </TableCell>
                          <TableCell className="cell-truncate">
                            {group.description || '—'}
                          </TableCell>
                          <TableCell>
                            {group.active_configs || 0} / {group.total_configs || 0}
                          </TableCell>
                          <TableCell>
                            {group.has_changes ? (
                              <Chip label="Change Detected" size="small" className="status-chip chip-orange" />
                            ) : (
                              <Chip label="No Changes" size="small" className="status-chip chip-grey" />
                            )}
                          </TableCell>
                          <TableCell>
                            <Chip
                              label={group.is_active ? 'Active' : 'Inactive'}
                              size="small"
                              className={`status-chip ${group.is_active ? 'status-active' : 'status-inactive'}`}
                            />
                          </TableCell>
                          <TableCell>
                            <div className='actions-menu'>
                              <IconButton onClick={(e) => this.setState({menuAnchorEl: e.currentTarget, menuOpenId: 'group_' + group.group_id})} data-testid="sm-group-menu">
                                <i className='material-icons'>more_horiz</i>
                              </IconButton>
                              <Menu
                                anchorEl={this.state.menuAnchorEl}
                                open={Boolean(this.state.menuAnchorEl) && this.state.menuOpenId === 'group_' + group.group_id}
                                onClose={() => this.setState({menuAnchorEl: null, menuOpenId: null})}
                                anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                                transformOrigin={{horizontal: 'right', vertical: 'top'}}
                              >
                                <MenuItemMUI
                                  className='wl-group-card-menu'
                                  onClick={() => this.handleViewGroupDetail(group)}
                                  data-testid="sm-group-menu-view"
                                >View Configs</MenuItemMUI>
                                <MenuItemMUI
                                  className='wl-group-card-menu'
                                  onClick={() => this.handleOpenEditGroup(group)}
                                  data-testid="sm-group-menu-edit"
                                >Edit</MenuItemMUI>
                                <MenuItemMUI
                                  className='wl-group-card-menu'
                                  onClick={() => this.handleToggleGroupActive(group)}
                                  data-testid="sm-group-menu-toggle"
                                >{group.is_active ? 'Deactivate' : 'Activate'}</MenuItemMUI>
                                <MenuItemMUI
                                  className='wl-group-card-menu'
                                  onClick={() => {
                                    this.setState({menuAnchorEl: null, menuOpenId: null});
                                    this.props.downloadGroupReport(group.group_id);
                                  }}
                                >Download Report</MenuItemMUI>
                                <MenuItemMUI
                                  className='wl-group-card-menu'
                                  onClick={() => this.handleDeleteGroupClick(group)}
                                  data-testid="sm-group-menu-delete"
                                >Delete</MenuItemMUI>
                              </Menu>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  )}
                  </div>
                </div>
              )}
            </ErrorBoundary>
          </div>
        )}

        {/* ── Config List / Group Detail View ───────────────────────────── */}
        <div id='' className={currentView === 'list' ? 'page-content results-container in' : 'page-content select-container'}>
          <ErrorBoundary>
            {isLoadingConfigs && <Preloader loading={true} />}

            <div className='cz-container'>
              {selectedGroup && (
                <div className="page-header-row">
                  <div className="page-header-title">
                    <h2>{selectedGroup.group_name}</h2>
                    {selectedGroup.description && (
                      <p className="group-description">{selectedGroup.description}</p>
                    )}
                  </div>
                  <div className="page-header-actions">
                    <Button label="Manage Configs in Group" className="btn btn-action" onClick={() => this.handleOpenAddConfigs(selectedGroup)} />
                    <Button label="Add New Monitor Config" className="btn" onClick={this.handleOpenCreate} />
                    <div>
                      <IconButton onClick={(e) => this.setState({menuAnchorEl: e.currentTarget, menuOpenId: 'selectedGroup'})}><i className='material-icons'>more_vert</i></IconButton>
                      <Menu anchorEl={this.state.menuAnchorEl} open={Boolean(this.state.menuAnchorEl) && this.state.menuOpenId === 'selectedGroup'} onClose={() => this.setState({menuAnchorEl: null, menuOpenId: null})}>
                        <MenuItemMUI
                          className='wl-group-card-menu'
                          onClick={() => this.handleToggleGroupActive(selectedGroup)}
                        >{selectedGroup.is_active ? 'Deactivate Group' : 'Activate Group'}</MenuItemMUI>
                        <MenuItemMUI
                          className='wl-group-card-menu'
                          onClick={() => {
                            this.setState({menuAnchorEl: null, menuOpenId: null});
                            this.props.downloadGroupReport(selectedGroup.group_id);
                          }}
                        >Download Report</MenuItemMUI>
                      </Menu>
                    </div>
                  </div>
                </div>
              )}
              {!selectedGroup && (
                <div className="page-header-row-centered">
                  <h2>Schema Change Monitor</h2>
                  <div className="page-header-actions">
                    <Button label="Add New Monitor Config" className="btn" onClick={this.handleOpenCreate} />
                  </div>
                </div>
              )}
              {displayConfigs.length === 0 && !isLoadingConfigs ? (
                <EmptyState message={selectedGroup ? 'No configurations in this group.' : 'You don\'t have any monitor configurations to display.'} />
              ) : (
                <Table className='data-table clickable'>
                  <TableHead>
                    <TableRow>
                      <TableCell>Instance</TableCell>
                      <TableCell>Schema</TableCell>
                      <TableCell>Frequency</TableCell>
                      <TableCell>Monitor</TableCell>
                      <TableCell>Run Status</TableCell>
                      <TableCell>Change Status</TableCell>
                      <TableCell>Last Run</TableCell>
                      <TableCell>Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {displayConfigs.map((config) => (
                      <TableRow key={config.config_id} hover>
                        <TableCell
                          className="link-text"
                          onClick={() => this.handleViewResults(config)}
                        >
                          {config.instance_name}
                        </TableCell>
                        <TableCell>{config.schema_name}</TableCell>
                        <TableCell>{config.frequency_minutes} min</TableCell>
                        <TableCell>
                          {[
                            config.monitor_tables && 'Tables',
                            config.monitor_views && 'Views',
                            config.monitor_stored_procedures && 'Stored Procedures',
                            (config.monitor_triggers !== undefined ? config.monitor_triggers : config.monitor_stored_procedures) && 'Triggers',
                            (config.monitor_functions !== undefined ? config.monitor_functions : config.monitor_stored_procedures) && 'Functions',
                            config.chat_provider && config.chat_provider !== 'none' && CHAT_PROVIDER_LABELS[config.chat_provider],
                          ].filter(Boolean).join(', ')}
                        </TableCell>
                        <TableCell>
                          <Chip
                            label={config.is_active ? 'Active' : 'Inactive'}
                            size="small"
                            className={`status-chip ${config.is_active ? 'status-active' : 'status-inactive'}`}
                          />
                        </TableCell>
                        <TableCell>
                          {config.has_changes ? (
                            <Chip label="Change Detected" size="small" className="status-chip chip-orange" />
                          ) : config.last_run_at ? (
                            <Chip label="No Changes" size="small" className="status-chip chip-grey" />
                          ) : (
                            <span>—</span>
                          )}
                        </TableCell>
                        <TableCell>
                          {config.last_run_at ? new Date(config.last_run_at).toLocaleString() : '—'}
                        </TableCell>
                        <TableCell>
                          <Tooltip title={config.is_active ? 'Run Now' : 'Monitor is inactive — activate it to run'}>
                            <span>
                              <IconButton
                                size="small"
                                onClick={() => this.handleRunNow(config.config_id)}
                                disabled={this.state.runningConfigId === config.config_id || !config.is_active}
                              >
                                <span className="material-icons">play_arrow</span>
                              </IconButton>
                            </span>
                          </Tooltip>
                          <div className='actions-menu'>
                            <IconButton onClick={(e) => this.setState({menuAnchorEl: e.currentTarget, menuOpenId: 'display_' + config.config_id})}>
                              <i className='material-icons'>more_horiz</i>
                            </IconButton>
                            <Menu
                              anchorEl={this.state.menuAnchorEl}
                              open={Boolean(this.state.menuAnchorEl) && this.state.menuOpenId === 'display_' + config.config_id}
                              onClose={() => this.setState({menuAnchorEl: null, menuOpenId: null})}
                              anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                              transformOrigin={{horizontal: 'right', vertical: 'top'}}
                            >
                              <MenuItemMUI
                                className='wl-group-card-menu'
                                onClick={() => this.handleViewResults(config)}
                              >View Results</MenuItemMUI>
                              <MenuItemMUI
                                className='wl-group-card-menu'
                                onClick={() => this.handleOpenEdit(config)}
                              >Edit</MenuItemMUI>
                              {selectedGroup && (
                                <MenuItemMUI
                                  className='wl-group-card-menu'
                                  onClick={() => this.handleRemoveConfigFromGroup(config.config_id)}
                                >Remove from Group</MenuItemMUI>
                              )}
                              <MenuItemMUI
                                className='wl-group-card-menu'
                                onClick={() => this.handleDisableClick(config)}
                              >Disable</MenuItemMUI>
                              <MenuItemMUI
                                className='wl-group-card-menu'
                                onClick={() => this.handleSoftDeleteClick(config)}
                              >Delete</MenuItemMUI>
                            </Menu>
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              )}
            </div>
          </ErrorBoundary>
        </div>

        {/* Results View */}
        <div id='' className={this.state.resultsClass}>
          <ErrorBoundary>
            <SchemaMonitorResults
              selectedConfig={selectedConfig}
              results={results}
              isLoadingResults={isLoadingResults}
              isRunning={selectedConfig ? runningConfigId === selectedConfig.config_id : false}
              onRunNow={this.handleRunNow}
              onViewChanges={this.handleViewChanges}
            />
          </ErrorBoundary>
        </div>

        {/* Change Details View */}
        <div id='' className={this.state.changesClass}>
          <ErrorBoundary>
            {selectedResult && (
              <div className='cz-container'>
                <h3>Change Details — {new Date(selectedResult.run_started_at).toLocaleString()}</h3>
                {isLoadingChanges && <Preloader loading={true} />}
                {changes.length === 0 && !isLoadingChanges ? (
                    <EmptyState message="No changes recorded." />
                  ) : (
                    <Table className='data-table'>
                      <TableHead>
                        <TableRow>
                          <TableCell>Level</TableCell>
                          <TableCell>Type</TableCell>
                          <TableCell>Object Name</TableCell>
                          <TableCell>Object Type</TableCell>
                          <TableCell>Column Name</TableCell>
                          <TableCell>Field Changed</TableCell>
                          <TableCell>Old Value</TableCell>
                          <TableCell>New Value</TableCell>
                          <TableCell>Workflow Status</TableCell>
                          <TableCell>Actions</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {changes.map((change) => (
                          <TableRow
                            key={change.change_id}
                            data-testid="schema-drift-row"
                            className="change-row-highlight"
                            style={{backgroundColor: CHANGE_TYPE_COLORS[change.change_type] + '15'}}
                          >
                            <TableCell>{change.change_level}</TableCell>
                            <TableCell>{this.renderChangeTypeChip(change.change_type)}</TableCell>
                            <TableCell>{change.object_name}</TableCell>
                            <TableCell>{change.object_type}</TableCell>
                            <TableCell>{change.column_name || '—'}</TableCell>
                            <TableCell>{change.field_changed ? (FIELD_CHANGED_LABELS[change.field_changed] || change.field_changed) : '—'}</TableCell>
                            <TableCell>
                              {/* Slice 2k: a withheld definition arrives as the '[redacted]'
                                  sentinel. Render the chip instead of the sentinel text. */}
                              {(change.redactedFields || []).includes('old_value') ? (
                          <RedactedChip fields={change.redactedFields} data-testid="sm-old-redacted" />
                        ) : change.old_value !== null && change.old_value !== undefined ? (
                          <code className="old-value">{change.old_value}</code>
                        ) : '—'}
                            </TableCell>
                            <TableCell>
                              {(change.redactedFields || []).includes('new_value') ? (
                          <RedactedChip fields={change.redactedFields} data-testid="sm-new-redacted" />
                        ) : change.new_value !== null && change.new_value !== undefined ? (
                          <code className="new-value">{change.new_value}</code>
                        ) : '—'}
                            </TableCell>
                            <TableCell>
                              {change.workflow_status ?
                          this.renderWorkflowStatusChip(change.workflow_status) :
                          <Chip label="No action" size="small" style={NO_ACTION_CHIP_STYLE} />
                              }
                            </TableCell>
                            <TableCell>
                              <div style={{display: 'flex', gap: 4, alignItems: 'center'}}>
                                {!change.workflow_status || change.workflow_status === 'PENDING' ? (
                            <Tooltip title="Review this change (Approve / Reject)">
                              <MuiButton
                                size="small"
                                variant="outlined"
                                color="primary"
                                onClick={() => this.openSmWorkflowDialog(change)}
                                style={{textTransform: 'none', whiteSpace: 'nowrap', fontSize: 12}}
                                startIcon={<span className="material-icons" style={{fontSize: 14}}>rate_review</span>}
                              >
                                Review
                              </MuiButton>
                            </Tooltip>
                          ) : null}
                                {this.canSmRollback(change.workflow_status) && (
                                  <Tooltip title={`Roll back this ${change.workflow_status} decision`}>
                                    <MuiButton
                                      size="small"
                                      variant="outlined"
                                      onClick={() => this.openSmRollbackDialog(change)}
                                      style={{borderColor: '#e65100', color: '#e65100', textTransform: 'none', fontSize: 12}}
                                      startIcon={<span className="material-icons" style={{fontSize: 14}}>undo</span>}
                                    >
                                Rollback
                                    </MuiButton>
                                  </Tooltip>
                                )}
                              </div>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
              )}
              </div>
            )}
          </ErrorBoundary>
        </div>

        {/* Workflow Action Side Sheet for Schema Monitor Changes */}
        <ChangeRequestDetailSheet
          open={this.state.smWorkflowDialogOpen}
          onClose={this.closeSmWorkflowDialog}
          changeRequest={this.transformSmChangeToWorkflowFormat(this.state.smSelectedChange)}
          changes={(this.props.changes || []).map((c) => this.transformSmChangeToWorkflowFormat(c))}
          isLoading={(this.props.isLoading || []).includes('smworkflowaction')}
          onNavigate={this.handleSmNavigate}
          onAction={this.submitSmWorkflowAction}
          onRollback={() => {
            const targetChange = this.state.smSelectedChange;
            this.closeSmWorkflowDialog();
            this.openSmRollbackDialog(targetChange);
          }}
        />

        {/* Rollback Confirmation Dialog for Schema Monitor Changes */}
        {this.renderSmRollbackDialog()}

        {/* New/Edit Config Drawer */}
        <Drawer
          anchor="right"
          open={configDialogOpen}
          onClose={this.handleCloseDialog}
          className="config-drawer"
        >
          <div className="detail-sheet-container">
            {/* Header */}
            <div className="detail-sheet-header">
              <div className="detail-sheet-header-content">
                <div className="detail-sheet-title">
                  <h2>{editingConfig ? 'Edit Monitor Config' : 'New Monitor Config'}</h2>
                </div>
                <div className="detail-sheet-actions">
                  <IconButton onClick={this.handleCloseDialog} size="small">
                    <span className="material-icons">close</span>
                  </IconButton>
                </div>
              </div>
            </div>

            {/* Content */}
            <div className="detail-sheet-content">
              {this.state.drawerError && (
                <Alert
                  ref={this.drawerErrorRef}
                  tabIndex={-1}
                  variant="danger"
                  onClose={() => this.setState({drawerError: null})}
                  dismissible
                  style={{margin: '0 0 16px 0'}}
                  data-testid="sm-config-drawer-error"
                >
                  <h4>{this.state.drawerError.title}</h4>
                  <p>{this.state.drawerError.message}</p>
                </Alert>
              )}
              {/* Instance dropdown */}
              <FormControl fullWidth className="form-group">
                <InputLabel className="form-field-label">Instance</InputLabel>
                <Select
                  value={selectedInstanceId}
                  onChange={this.handleInstanceChange}
                  disabled={!!editingConfig}
                  className="form-field-input"
                  inputProps={{'data-testid': 'sm-config-instance-select'}}
                >
                  {/* schemaMonitorService.createRemoteConnection is MySQL-only, so a
                      config on an MSSQL instance would be scheduled and then fail on
                      every run. Not selectable until that path is type-aware. */}
                  {(instances || []).map((inst) => (
                    <MenuItem
                      key={inst.instanceId}
                      value={inst.instanceId}
                      className="form-field-menu-item"
                      disabled={!!schemaMonitorUnsupportedReason(inst)}
                    >
                      {inst.instanceName}
                      {inst.instanceType ? ` (${inst.instanceType})` : ''}
                      {inst.host ? ` — ${inst.host}` : ''}
                      {schemaMonitorUnsupportedReason(inst) ? ' — not supported for MS SQL Server' : ''}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {/* Schema dropdown */}
              <FormControl fullWidth className="form-group">
                <InputLabel className="form-field-label">Schema</InputLabel>
                <Select
                  value={selectedSchemaId}
                  onChange={(e) => this.setState({selectedSchemaId: e.target.value})}
                  disabled={!selectedInstanceId || !!editingConfig}
                  className="form-field-input"
                  inputProps={{'data-testid': 'sm-config-schema-select'}}
                >
                  {(schemas || []).map((schema) => (
                    <MenuItem key={schema.schemaId} value={schema.schemaId} className="form-field-menu-item">
                      {schema.schemaName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {/* Frequency presets */}
              <FormControl fullWidth className="form-group">
                <InputLabel className="form-field-label">Frequency</InputLabel>
                <Select
                  value={frequencyPreset}
                  onChange={(e) => this.setState({frequencyPreset: e.target.value})}
                  className="form-field-input"
                >
                  {FREQUENCY_PRESETS.map((preset) => (
                    <MenuItem key={preset.value} value={preset.value} className="form-field-menu-item">
                      {preset.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {frequencyPreset === 'custom' && (
                <TextField
                  label="Custom Frequency (minutes)"
                  type="number"
                  fullWidth
                  value={customFrequency}
                  onChange={(e) => this.setState({customFrequency: e.target.value})}
                  inputProps={{min: 1}}
                  className="form-group"
                />
              )}

              {/* Schedule window */}
              <div className="form-section-boxed">
                <div className="form-group">
                  <FormControlLabel
                    control={<Switch checked={isActive} onChange={(e) => this.setState({isActive: e.target.checked})} color="primary" />}
                    label={isActive ? 'Active' : 'Inactive'}
                  />
                </div>
                <h4 className="form-section-header">Schedule Window</h4>
                <p className="form-section-description">Set a start and end date/time to define a monitoring period. Leave empty to run at all times.</p>

                <div className="form-fields-row form-group">
                  <TextField
                    label="Start Date"
                    type="date"
                    value={monitorStartDate}
                    onChange={(e) => this.setState({monitorStartDate: e.target.value, drawerError: null})}
                    InputLabelProps={{shrink: true}}
                    helperText="Monitoring begins from this date and time"
                  />
                  <TextField
                    label="Start Time"
                    type="time"
                    value={monitorStartTime}
                    onChange={(e) => this.setState({monitorStartTime: e.target.value, drawerError: null})}
                    InputLabelProps={{shrink: true}}
                  />
                </div>
                <div className="form-fields-row">
                  <TextField
                    label="End Date"
                    type="date"
                    value={monitorEndDate}
                    onChange={(e) => this.setState({monitorEndDate: e.target.value, drawerError: null})}
                    InputLabelProps={{shrink: true}}
                    helperText="Monitoring ends and config auto-disables after this date and time"
                  />
                  <TextField
                    label="End Time"
                    type="time"
                    value={monitorEndTime}
                    onChange={(e) => this.setState({monitorEndTime: e.target.value, drawerError: null})}
                    InputLabelProps={{shrink: true}}
                  />
                </div>
              </div>

              {/* Items to be Monitored */}
              <div className="form-section-boxed">
                <h4 className="form-section-header">Items to be Monitored</h4>
                <div className="form-fields-group">
                  <FormControlLabel
                    control={<Checkbox checked={monitorTables} onChange={(e) => this.setState({monitorTables: e.target.checked})} color="primary" />}
                    label="Tables"
                  />
                  <FormControlLabel
                    control={<Checkbox checked={monitorViews} onChange={(e) => this.setState({monitorViews: e.target.checked})} color="primary" />}
                    label="Views"
                  />
                  <FormControlLabel
                    control={<Checkbox checked={monitorStoredProcedures} onChange={(e) => this.setState({monitorStoredProcedures: e.target.checked})} color="primary" />}
                    label="Stored Procedures"
                  />
                  <FormControlLabel
                    control={<Checkbox checked={monitorTriggers} onChange={(e) => this.setState({monitorTriggers: e.target.checked})} color="primary" />}
                    label="Triggers"
                  />
                  <FormControlLabel
                    control={<Checkbox checked={monitorFunctions} onChange={(e) => this.setState({monitorFunctions: e.target.checked})} color="primary" />}
                    label="Functions"
                  />
                </div>
              </div>

              {/* Notify on Change */}
              <div className="form-section-boxed">
                <FormControlLabel
                  control={<Checkbox checked={notifyOnChange} onChange={(e) => this.setState({notifyOnChange: e.target.checked})} color="primary" />}
                  label="Notify on Change"
                />
                <div className="nested-form-fields">
                  <FormControl fullWidth className="form-group">
                    <InputLabel>Chat Provider</InputLabel>
                    <Select
                      value={chatProvider}
                      onChange={(e) => this.setState({chatProvider: e.target.value})}
                      disabled={!notifyOnChange}
                    >
                      <MenuItem value="none">None</MenuItem>
                      <MenuItem value="slack">Slack</MenuItem>
                      <MenuItem value="teams">Microsoft Teams</MenuItem>
                      <MenuItem value="gchat">Google Chat</MenuItem>
                    </Select>
                  </FormControl>
                  {chatProvider !== 'none' && (
                    <>
                      <TextField
                        label="Webhook URL"
                        fullWidth
                        value={chatWebhookUrl}
                        onChange={(e) => this.setState({chatWebhookUrl: e.target.value})}
                        placeholder="https://hooks.slack.com/services/..."
                        disabled={!notifyOnChange}
                      />
                      <TextField
                        label="Channel Name (optional)"
                        fullWidth
                        value={chatChannelName}
                        onChange={(e) => this.setState({chatChannelName: e.target.value})}
                        placeholder="#schema-alerts"
                        disabled={!notifyOnChange}
                      />
                    </>
                  )}
                </div>
              </div>
            </div>

            {/* Footer Actions */}
            <div className="detail-sheet-footer">
              <Button
                label={editingConfig ? 'Save Changes' : 'Create Monitor'}
                className="btn btn-action"
                onClick={this.handleSaveConfig}
                disabled={!selectedInstanceId || !selectedSchemaId}
                data-testid="sm-config-save-btn"
              />
              <Button label="Cancel" className="btn btn-default" onClick={this.handleCloseDialog} data-testid="sm-config-cancel-btn" />
            </div>
          </div>
        </Drawer>

        {/* Create/Edit Group Dialog */}
        <Dialog open={groupDialogOpen} onClose={this.handleCloseGroupDialog} maxWidth="sm" fullWidth data-testid="sm-group-dialog">
          <DialogTitle>{editingGroup ? 'Edit Group' : 'New Monitor Group'}</DialogTitle>
          <DialogContent>
            <TextField
              label="Group Name"
              fullWidth
              value={groupName}
              onChange={(e) => this.setState({groupName: e.target.value})}
              required
              className="form-group"
              inputProps={{'data-testid': 'sm-group-name-input'}}
            />
            <TextField
              label="Description (optional)"
              fullWidth
              multiline
              rows={2}
              value={groupDescription}
              onChange={(e) => this.setState({groupDescription: e.target.value})}
              className="form-group"
            />
            <FormControlLabel
              control={<Switch checked={groupIsActive} onChange={(e) => this.setState({groupIsActive: e.target.checked})} color="primary" />}
              label="Active"
            />
          </DialogContent>
          <DialogActions>
            <Button label="Cancel" className="btn btn-default" onClick={this.handleCloseGroupDialog} data-testid="sm-group-cancel-btn" />
            <Button
              label={editingGroup ? 'Save Changes' : 'Create Group'}
              className="btn btn-action"
              onClick={this.handleSaveGroup}
              disabled={!groupName.trim()}
              data-testid="sm-group-save-btn"
            />
          </DialogActions>
        </Dialog>

        {/* Manage Configs in Group Drawer */}
        <Drawer
          anchor="right"
          open={addConfigsDialogOpen}
          onClose={this.handleCloseAddConfigs}
          className="config-drawer"
        >
          <div className="detail-sheet-container">
            <div className="detail-sheet-header">
              <div className="detail-sheet-header-content">
                <div className="detail-sheet-title">
                  <h2>Manage Configs in {selectedGroup && selectedGroup.group_name}</h2>
                </div>
                <div className="detail-sheet-actions">
                  <IconButton onClick={this.handleCloseAddConfigs} size="small">
                    <span className="material-icons">close</span>
                  </IconButton>
                </div>
              </div>
            </div>

            <div className="detail-sheet-content">
              {configs.length === 0 ? (
                <p className="text-muted">No configurations available.</p>
              ) : (
                <div>
                  <p className="text-muted-hint">Select configurations to include in this group:</p>
                  <div className="form-fields-group" style={{marginTop: 16}}>
                    {configs.map((config) => (
                      <FormControlLabel
                        key={config.config_id}
                        control={
                          <Checkbox
                            checked={selectedConfigIds.includes(config.config_id)}
                            onChange={(e) => {
                              if (e.target.checked) {
                                this.setState({selectedConfigIds: [...selectedConfigIds, config.config_id]});
                              } else {
                                this.setState({selectedConfigIds: selectedConfigIds.filter((id) => id !== config.config_id)});
                              }
                            }}
                            color="primary"
                          />
                        }
                        label={`${config.instance_name} / ${config.schema_name}`}
                      />
                    ))}
                  </div>
                </div>
              )}
            </div>

            <div className="detail-sheet-footer">
              <Button
                label="Save Changes"
                className="btn btn-action"
                onClick={this.handleAssignConfigs}
                disabled={configs.length === 0}
              />
              <Button label="Cancel" className="btn btn-default" onClick={this.handleCloseAddConfigs} />
            </div>
          </div>
        </Drawer>

      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  configs: state.schemaMonitorReducer.configs,
  results: state.schemaMonitorReducer.results,
  changes: state.schemaMonitorReducer.changes,
  dashboard: state.schemaMonitorReducer.dashboard,
  instances: state.schemaMonitorReducer.instances,
  schemas: state.schemaMonitorReducer.schemas,
  groups: state.schemaMonitorReducer.groups,
  groupConfigs: state.schemaMonitorReducer.groupConfigs,
  isLoading: state.schemaMonitorReducer.isLoading,
  error: state.schemaMonitorReducer.error,
  runResult: state.schemaMonitorReducer.runResult,
});

const mapDispatchToProps = {
  loadConfigs,
  createConfig,
  updateConfig,
  deleteConfig,
  disableConfig,
  softDeleteConfig,
  loadResults,
  loadChanges,
  runNow,
  loadDashboard,
  loadInstances,
  loadSchemas,
  clearResults,
  loadGroups,
  createGroup,
  updateGroup,
  deleteGroup,
  loadGroupConfigs,
  assignConfigsToGroup,
  removeConfigFromGroup,
  activateGroup,
  deactivateGroup,
  downloadGroupReport,
  applySchemaChangeWorkflowAction,
  rollbackSchemaChangeAction,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SchemaMonitor));
